<template>
    <div class="wrapper-user">
        <b-container class="contentcontainer">
            <b-row align-v="center" class="contentcontainer__head">
              <b-col>
                <h2>Personal Information</h2>
              </b-col>
              <b-col>
                <div class="actions">
                  <button v-if="editModeUser" class="btn btn-small btn--danger" @click="cancelEditUser"><span class="icon"><font-awesome-icon :icon="['fal','times']"></font-awesome-icon></span><span class="text">Cancel</span></button>
                  <button v-if="editModeUser" class="btn btn-small btn--success" @click="updateUser"><span class="icon"><font-awesome-icon :icon="['fal','check']"></font-awesome-icon></span><span class="text">Save</span></button>
                  <button class="btn btn--link" v-else @click="editUser"><span class="icon"><font-awesome-icon :icon="['fal','edit']"></font-awesome-icon></span><span class="text">Edit</span></button>
                </div>
              </b-col>
            </b-row>
            <hr/>
            <b-row cols="1">
              <b-col lg="8">
                <div class="form-group">
                  <label for="firstname">Firstname</label>
                  <input type="text" class="form-control" id="firstname" aria-describedby="firstnameHelp" v-model="user.firstname" :readonly="!editModeUser">
                </div>
              </b-col>
              <b-col lg="8">
                <div class="form-group">
                  <label for="lastname">Lastname</label>
                  <input type="text" class="form-control" id="lastname" aria-describedby="lastnameHelp" v-model="user.lastname" :readonly="!editModeUser">
                </div>
              </b-col>
              <hr/>
              <b-col lg="8">
                <div class="form-group">
                  <label for="password">Password</label>
                  <input type="password" class="form-control" id="password" aria-describedby="passwordHelp" v-model="password" :readonly="!editModeUser">
                </div>
              </b-col>
              <b-col lg="8">
                <div class="form-group confirm-password">
                  <label for="confirm">Confirm Password</label>
                  <input type="password" class="form-control" id="confirm" aria-describedby="confirmHelp" v-model="confirm" :readonly="!editModeUser">
                  <span v-show="!passwordsMatch" class="notice">Passwords don't Match</span>
                </div>
              </b-col>
              <b-col lg="8">
                <div class="form-group">
                  <label for="email">Email address</label>
                  <input type="email" class="form-control" id="email" aria-describedby="emailHelp" placeholder="Enter email" v-model="user.email" readonly="readonly">
                </div>
              </b-col>
              <hr/>
              <b-col lg="8">
                <div class="form-group">
                  <label for="timezone">Timezone</label>
                  <select class="form-control"
                          id="timezone"
                          v-model="user.timezone"
                          required="required"
                          :readonly="!editModeUser"
                  >
                    <option value="-12">-12</option>
                    <option value="-11">-11</option>
                    <option value="-10">-10</option>
                    <option value="-9">-9</option>
                    <option value="-8">-8</option>
                    <option value="-7">-7</option>
                    <option value="-6">-6</option>
                    <option value="-5">-5</option>
                    <option value="-4">-4</option>
                    <option value="-3">-3</option>
                    <option value="-2">-2</option>
                    <option value="-1">-1</option>
                    <option value="0">UTC</option>
                    <option value="1">+1</option>
                    <option value="2">+2</option>
                    <option value="3">+3</option>
                    <option value="4">+4</option>
                    <option value="5">+5</option>
                    <option value="6">+6</option>
                    <option value="7">+7</option>
                    <option value="8">+8</option>
                    <option value="9">+9</option>
                    <option value="10">+10</option>
                    <option value="11">+11</option>
                    <option value="12">+12</option>
                  </select>
                </div>
              </b-col>
            </b-row>
        </b-container>
        <b-container class="contentcontainer">
          <b-row align-v="center" class="contentcontainer__head">
            <b-col>
              <h2>Account Information</h2>
            </b-col>
            <b-col>
              <div class="actions">
                <button v-if="editModeAccount" class="btn btn-small btn--danger" @click="cancelEditAccount"><span class="icon"><font-awesome-icon :icon="['fal','times']"></font-awesome-icon></span><span class="text">Cancel</span></button>
                <button v-if="editModeAccount" class="btn btn-small btn--success" @click="updateAccount"><span class="icon"><font-awesome-icon :icon="['fal','check']"></font-awesome-icon></span><span class="text">Save</span></button>
                <button class="btn btn--link" v-else @click="editAccount"><span class="icon"><font-awesome-icon :icon="['fal','edit']"></font-awesome-icon></span><span class="text">Edit</span></button>
              </div>
            </b-col>
          </b-row>
          <hr/>
          <b-row cols="1">
            <b-col lg="8">
              <div class="form-group">
                <label for="company">Company</label>
                <input type="text" class="form-control" id="company" aria-describedby="companyHelp" v-model="account.company" :readonly="!editModeAccount">
              </div>
            </b-col>
            <b-col>
              <b-row>
                <b-col lg="8">
                  <div class="form-group">
                    <label for="logo">Logo</label>
                    <input type="file" class="form-control" id="logo" :disabled="!editModeAccount" ref="logofile" @change="logofile = $refs.logofile.files[0]">
                  </div>
                </b-col>
                <b-col  lg="4">
                  <img :src="account.logo_url" v-if="account.logo" class="img-fluid"/>
                </b-col>
              </b-row>
            </b-col>
            <hr/>
            <b-col lg="8">
              <div class="form-group">
                <label for="street">Street</label>
                <input type="text" class="form-control" id="street" aria-describedby="lastnameHelp" v-model="account.street" :readonly="!editModeAccount">
              </div>
            </b-col>
            <b-col lg="8">
              <div class="form-group">
                <label for="housenumber">Housenumber</label>
                <input type="text" class="form-control" id="housenumber" aria-describedby="housenumberHelp" v-model="account.housenumber" :readonly="!editModeAccount">
              </div>
            </b-col>
            <b-col lg="8">
              <div class="form-group">
                <label for="zip">Zip</label>
                <input type="text" class="form-control" id="zip" aria-describedby="zipHelp" v-model="account.zip" :readonly="!editModeAccount">
              </div>
            </b-col>
            <b-col lg="8">
              <div class="form-group">
                <label for="city">City</label>
                <input type="text" class="form-control" id="city" aria-describedby="cityHelp" v-model="account.city" :readonly="!editModeAccount">
              </div>
            </b-col>
            <b-col lg="8">
              <div class="form-group">
                <label for="country">Country</label>
                <select class="form-control"
                        id="country"
                        aria-describedby="countryHelp"
                        v-model="account.country"
                        v-bind:disabled="!editModeAccount"
                        required="required"
                >
                  <option value="AF">Afghanistan</option>
                  <option value="AX">Åland Islands</option>
                  <option value="AL">Albania</option>
                  <option value="DZ">Algeria</option>
                  <option value="AS">American Samoa</option>
                  <option value="AD">Andorra</option>
                  <option value="AO">Angola</option>
                  <option value="AI">Anguilla</option>
                  <option value="AQ">Antarctica</option>
                  <option value="AG">Antigua and Barbuda</option>
                  <option value="AR">Argentina</option>
                  <option value="AM">Armenia</option>
                  <option value="AW">Aruba</option>
                  <option value="AU">Australia</option>
                  <option value="AT">Austria</option>
                  <option value="AZ">Azerbaijan</option>
                  <option value="BS">Bahamas</option>
                  <option value="BH">Bahrain</option>
                  <option value="BD">Bangladesh</option>
                  <option value="BB">Barbados</option>
                  <option value="BY">Belarus</option>
                  <option value="BE">Belgium</option>
                  <option value="BZ">Belize</option>
                  <option value="BJ">Benin</option>
                  <option value="BM">Bermuda</option>
                  <option value="BT">Bhutan</option>
                  <option value="BO">Bolivia, Plurinational State of</option>
                  <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                  <option value="BA">Bosnia and Herzegovina</option>
                  <option value="BW">Botswana</option>
                  <option value="BV">Bouvet Island</option>
                  <option value="BR">Brazil</option>
                  <option value="IO">British Indian Ocean Territory</option>
                  <option value="BN">Brunei Darussalam</option>
                  <option value="BG">Bulgaria</option>
                  <option value="BF">Burkina Faso</option>
                  <option value="BI">Burundi</option>
                  <option value="KH">Cambodia</option>
                  <option value="CM">Cameroon</option>
                  <option value="CA">Canada</option>
                  <option value="CV">Cape Verde</option>
                  <option value="KY">Cayman Islands</option>
                  <option value="CF">Central African Republic</option>
                  <option value="TD">Chad</option>
                  <option value="CL">Chile</option>
                  <option value="CN">China</option>
                  <option value="CX">Christmas Island</option>
                  <option value="CC">Cocos (Keeling) Islands</option>
                  <option value="CO">Colombia</option>
                  <option value="KM">Comoros</option>
                  <option value="CG">Congo</option>
                  <option value="CD">Congo, the Democratic Republic of the</option>
                  <option value="CK">Cook Islands</option>
                  <option value="CR">Costa Rica</option>
                  <option value="CI">Côte d'Ivoire</option>
                  <option value="HR">Croatia</option>
                  <option value="CU">Cuba</option>
                  <option value="CW">Curaçao</option>
                  <option value="CY">Cyprus</option>
                  <option value="CZ">Czech Republic</option>
                  <option value="DK">Denmark</option>
                  <option value="DJ">Djibouti</option>
                  <option value="DM">Dominica</option>
                  <option value="DO">Dominican Republic</option>
                  <option value="EC">Ecuador</option>
                  <option value="EG">Egypt</option>
                  <option value="SV">El Salvador</option>
                  <option value="GQ">Equatorial Guinea</option>
                  <option value="ER">Eritrea</option>
                  <option value="EE">Estonia</option>
                  <option value="ET">Ethiopia</option>
                  <option value="FK">Falkland Islands (Malvinas)</option>
                  <option value="FO">Faroe Islands</option>
                  <option value="FJ">Fiji</option>
                  <option value="FI">Finland</option>
                  <option value="FR">France</option>
                  <option value="GF">French Guiana</option>
                  <option value="PF">French Polynesia</option>
                  <option value="TF">French Southern Territories</option>
                  <option value="GA">Gabon</option>
                  <option value="GM">Gambia</option>
                  <option value="GE">Georgia</option>
                  <option value="DE">Germany</option>
                  <option value="GH">Ghana</option>
                  <option value="GI">Gibraltar</option>
                  <option value="GR">Greece</option>
                  <option value="GL">Greenland</option>
                  <option value="GD">Grenada</option>
                  <option value="GP">Guadeloupe</option>
                  <option value="GU">Guam</option>
                  <option value="GT">Guatemala</option>
                  <option value="GG">Guernsey</option>
                  <option value="GN">Guinea</option>
                  <option value="GW">Guinea-Bissau</option>
                  <option value="GY">Guyana</option>
                  <option value="HT">Haiti</option>
                  <option value="HM">Heard Island and McDonald Islands</option>
                  <option value="VA">Holy See (Vatican City State)</option>
                  <option value="HN">Honduras</option>
                  <option value="HK">Hong Kong</option>
                  <option value="HU">Hungary</option>
                  <option value="IS">Iceland</option>
                  <option value="IN">India</option>
                  <option value="ID">Indonesia</option>
                  <option value="IR">Iran, Islamic Republic of</option>
                  <option value="IQ">Iraq</option>
                  <option value="IE">Ireland</option>
                  <option value="IM">Isle of Man</option>
                  <option value="IL">Israel</option>
                  <option value="IT">Italy</option>
                  <option value="JM">Jamaica</option>
                  <option value="JP">Japan</option>
                  <option value="JE">Jersey</option>
                  <option value="JO">Jordan</option>
                  <option value="KZ">Kazakhstan</option>
                  <option value="KE">Kenya</option>
                  <option value="KI">Kiribati</option>
                  <option value="KP">Korea, Democratic People's Republic of</option>
                  <option value="KR">Korea, Republic of</option>
                  <option value="KW">Kuwait</option>
                  <option value="KG">Kyrgyzstan</option>
                  <option value="LA">Lao People's Democratic Republic</option>
                  <option value="LV">Latvia</option>
                  <option value="LB">Lebanon</option>
                  <option value="LS">Lesotho</option>
                  <option value="LR">Liberia</option>
                  <option value="LY">Libya</option>
                  <option value="LI">Liechtenstein</option>
                  <option value="LT">Lithuania</option>
                  <option value="LU">Luxembourg</option>
                  <option value="MO">Macao</option>
                  <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                  <option value="MG">Madagascar</option>
                  <option value="MW">Malawi</option>
                  <option value="MY">Malaysia</option>
                  <option value="MV">Maldives</option>
                  <option value="ML">Mali</option>
                  <option value="MT">Malta</option>
                  <option value="MH">Marshall Islands</option>
                  <option value="MQ">Martinique</option>
                  <option value="MR">Mauritania</option>
                  <option value="MU">Mauritius</option>
                  <option value="YT">Mayotte</option>
                  <option value="MX">Mexico</option>
                  <option value="FM">Micronesia, Federated States of</option>
                  <option value="MD">Moldova, Republic of</option>
                  <option value="MC">Monaco</option>
                  <option value="MN">Mongolia</option>
                  <option value="ME">Montenegro</option>
                  <option value="MS">Montserrat</option>
                  <option value="MA">Morocco</option>
                  <option value="MZ">Mozambique</option>
                  <option value="MM">Myanmar</option>
                  <option value="NA">Namibia</option>
                  <option value="NR">Nauru</option>
                  <option value="NP">Nepal</option>
                  <option value="NL">Netherlands</option>
                  <option value="NC">New Caledonia</option>
                  <option value="NZ">New Zealand</option>
                  <option value="NI">Nicaragua</option>
                  <option value="NE">Niger</option>
                  <option value="NG">Nigeria</option>
                  <option value="NU">Niue</option>
                  <option value="NF">Norfolk Island</option>
                  <option value="MP">Northern Mariana Islands</option>
                  <option value="NO">Norway</option>
                  <option value="OM">Oman</option>
                  <option value="PK">Pakistan</option>
                  <option value="PW">Palau</option>
                  <option value="PS">Palestinian Territory, Occupied</option>
                  <option value="PA">Panama</option>
                  <option value="PG">Papua New Guinea</option>
                  <option value="PY">Paraguay</option>
                  <option value="PE">Peru</option>
                  <option value="PH">Philippines</option>
                  <option value="PN">Pitcairn</option>
                  <option value="PL">Poland</option>
                  <option value="PT">Portugal</option>
                  <option value="PR">Puerto Rico</option>
                  <option value="QA">Qatar</option>
                  <option value="RE">Réunion</option>
                  <option value="RO">Romania</option>
                  <option value="RU">Russian Federation</option>
                  <option value="RW">Rwanda</option>
                  <option value="BL">Saint Barthélemy</option>
                  <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                  <option value="KN">Saint Kitts and Nevis</option>
                  <option value="LC">Saint Lucia</option>
                  <option value="MF">Saint Martin (French part)</option>
                  <option value="PM">Saint Pierre and Miquelon</option>
                  <option value="VC">Saint Vincent and the Grenadines</option>
                  <option value="WS">Samoa</option>
                  <option value="SM">San Marino</option>
                  <option value="ST">Sao Tome and Principe</option>
                  <option value="SA">Saudi Arabia</option>
                  <option value="SN">Senegal</option>
                  <option value="RS">Serbia</option>
                  <option value="SC">Seychelles</option>
                  <option value="SL">Sierra Leone</option>
                  <option value="SG">Singapore</option>
                  <option value="SX">Sint Maarten (Dutch part)</option>
                  <option value="SK">Slovakia</option>
                  <option value="SI">Slovenia</option>
                  <option value="SB">Solomon Islands</option>
                  <option value="SO">Somalia</option>
                  <option value="ZA">South Africa</option>
                  <option value="GS">South Georgia and the South Sandwich Islands</option>
                  <option value="SS">South Sudan</option>
                  <option value="ES">Spain</option>
                  <option value="LK">Sri Lanka</option>
                  <option value="SD">Sudan</option>
                  <option value="SR">Suriname</option>
                  <option value="SJ">Svalbard and Jan Mayen</option>
                  <option value="SZ">Swaziland</option>
                  <option value="SE">Sweden</option>
                  <option value="CH">Switzerland</option>
                  <option value="SY">Syrian Arab Republic</option>
                  <option value="TW">Taiwan, Province of China</option>
                  <option value="TJ">Tajikistan</option>
                  <option value="TZ">Tanzania, United Republic of</option>
                  <option value="TH">Thailand</option>
                  <option value="TL">Timor-Leste</option>
                  <option value="TG">Togo</option>
                  <option value="TK">Tokelau</option>
                  <option value="TO">Tonga</option>
                  <option value="TT">Trinidad and Tobago</option>
                  <option value="TN">Tunisia</option>
                  <option value="TR">Turkey</option>
                  <option value="TM">Turkmenistan</option>
                  <option value="TC">Turks and Caicos Islands</option>
                  <option value="TV">Tuvalu</option>
                  <option value="UG">Uganda</option>
                  <option value="UA">Ukraine</option>
                  <option value="AE">United Arab Emirates</option>
                  <option value="GB">United Kingdom</option>
                  <option value="US">United States</option>
                  <option value="UM">United States Minor Outlying Islands</option>
                  <option value="UY">Uruguay</option>
                  <option value="UZ">Uzbekistan</option>
                  <option value="VU">Vanuatu</option>
                  <option value="VE">Venezuela, Bolivarian Republic of</option>
                  <option value="VN">Viet Nam</option>
                  <option value="VG">Virgin Islands, British</option>
                  <option value="VI">Virgin Islands, U.S.</option>
                  <option value="WF">Wallis and Futuna</option>
                  <option value="EH">Western Sahara</option>
                  <option value="YE">Yemen</option>
                  <option value="ZM">Zambia</option>
                  <option value="ZW">Zimbabwe</option>
                </select>
              </div>
            </b-col>
            <hr/>
            <b-col lg="8">
              <div class="form-group">
                <label for="vatid">VAT-ID</label>
                <input type="text" class="form-control" id="vatid" aria-describedby="vatidHelp" v-model="account.vatid" :readonly="!editModeAccount">
              </div>
            </b-col>
            <b-col lg="8">
              <div class="form-group" v-show="!editModeAccount && account.vatid_valid_check_date !== ''">
                VatId last check date: {{ account.vatid_valid_check_date }}<br>
                VatId was <span v-if="account.vatid_is_valid">Valid</span><span v-else>Invalid</span>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <b-container class="contentcontainer">
          <b-row class="contentcontainer__head">
            <b-col>
              <h2>Delete Account</h2>
            </b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col class="account" v-if="account.pre_delete === false">
              <div>
                Don't want to use our service anymore? No problem!<br/>
                You can remove your account here, don't worry there is a confirmation page.
              </div>
            </b-col>
          </b-row>
          <b-row align-h="end" class="contentcontainer__footer">
            <b-col cols="auto">
              <button v-on:click="localRemove" class="btn btn--danger">
                {{$t('user.remove')}}
                <span class="icon">
                        <font-awesome-icon :icon="['fal','trash']"></font-awesome-icon>
                    </span>
              </button>
            </b-col>
            <b-col class="account" v-if="account.pre_delete === true">
              You deleted your account at {{ account.pre_delete_date }}. We will remove your account at the beginning of next month
            </b-col>
          </b-row>
        </b-container>
    </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from 'vuex'
import FormData from 'json-form-data'

export default {
  name: 'Profile',

  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      account: 'getAccount'
    }),

    userAvatar () {
      return this.user.avatar
    }
  },

  data () {
    return {
      logofile: null,

      password: '',
      confirm: '',

      passwordsMatch: true,

      editModeUser: false,
      editModeAccount: false,
      savedData: {}
    }
  },

  watch: {
    'password': function () {
      this.passwordsMatch = this.password === this.confirm
    },
    'confirm': function () {
      this.passwordsMatch = this.password === this.confirm
    }
  },

  methods: {

    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    ...mapActions('user', [
      'getAccount',
      'getUser'
    ]),

    ...mapMutations('user', [
      'setUserFirstname',
      'setUserLastname',
      'setUserTimezone'
    ]),

    cancelEditAccount () {
      this.user = this.savedData
      this.editModeAccount = false
    },

    cancelEditUser () {
      this.user = this.savedData
      this.editModeUser = false
    },

    editAccount () {
      this.savedData = { ...this.user }
      this.editModeAccount = true
    },

    editUser () {
      this.savedData = { ...this.user }
      this.editModeUser = true
    },

    localRemove () {
      this.$router.push({
        name: 'userDestroy',
        params: {
          id: this.user.id
        }
      })
    },

    updateAccount () {
      let data = Object.assign({}, this.account)
      Reflect.deleteProperty(data, 'logo')
      Reflect.deleteProperty(data, 'logo_url')

      data = new FormData(data)

      // Append main image and tos file
      if (this.logofile) {
        data.append('logofile', this.logofile)
      }

      // server call to update data
      this.axios.post('/api/account', data).then(
        response => {
          this.getAccount()
          this.editModeAccount = false
        }
      )
    },

    updateUser () {
      if (this.passwordsMatch) {
        // Do we have a password to update
        if (this.password !== '') {
          this.user.password = this.password
        }

        // server call to update data
        this.axios.put('/api/user', this.user).then(
          response => {
            this.getUser()
            this.editModeUser = false
          }
        )
      }
    }
  }
}
</script>
